import { render, staticRenderFns } from "./cg-content-image.vue?vue&type=template&id=012e8afd&scoped=true"
import script from "./cg-content-image.vue?vue&type=script&lang=js"
export * from "./cg-content-image.vue?vue&type=script&lang=js"
import style0 from "./cg-content-image.vue?vue&type=style&index=0&id=012e8afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012e8afd",
  null
  
)

export default component.exports